import React from 'react';
import PaymentGatewayTabs from './component/PaymentGatewayTabs';

const PaymentGatewayPage = ({ pageTitle }) => {
    return <PaymentGatewayTabs />;
};

export default PaymentGatewayPage;
